import * as React from 'react';
import classnames from 'classnames';
import { List } from '@grandvisionhq/common';
import { Heading, Text } from '@grandvisionhq/elements';
import { useIntl } from '@grandvisionhq/state';

const ProductDetailDescription = ({ className , children , description , header , title: propTitle , usps ,  })=>{
    const { getLabel  } = useIntl();
    // TODO: replace this label with something more generic
    const title = propTitle || getLabel('products.contactLenses.header.details');
    return /*#__PURE__*/ React.createElement("section", {
        className: classnames('product-detail-description', className),
        "aria-label": title,
        "data-t": "product-detail-description"
    }, title && /*#__PURE__*/ React.createElement(Heading, {
        variant: "smallest",
        component: "h2"
    }, title), usps && /*#__PURE__*/ React.createElement(List, {
        className: "product-detail-description__list",
        icon: "checkmark",
        items: usps
    }), header && /*#__PURE__*/ React.createElement(Heading, {
        variant: "subheading1",
        className: "product-detail-description__subheading",
        component: "h3"
    }, header), description && /*#__PURE__*/ React.createElement(Text, {
        variant: "body"
    }, description), children);
};

export { ProductDetailDescription };
//# sourceMappingURL=ProductDetailDescription.js.map
